import { start } from 'single-spa';

let singleSpaStarted = false;

/**
 * Ensures single-spa is started only once across all MFEs.
 * This prevents the "patchHistoryApi() was called after the history api was already patched" error
 * when multiple parcels try to initialize single-spa.
 */
export function ensureSingleSpaStarted(): void {
  if (!singleSpaStarted) {
    start();
    singleSpaStarted = true;
  }
}
